

// ------------------------------------
// Constants
// ------------------------------------
const LOGIN_PHONE_NUMBER_CHANGE = 'LOGIN_PHONE_NUMBER_CHANGE';
const LOGIN_PASSWORD_CHANGE = 'LOGIN_PASSWORD_CHANGE';
const MARK_AS_AUTHENTICATED = 'MARK_AS_AUTHENTICATED';

// ------------------------------------
// Actions
// ------------------------------------
function changePhoneNumber(value = '') {
  return {
    type    : LOGIN_PHONE_NUMBER_CHANGE,
    payload : value
  }
}

function changePassword(value = '') {
  return {
    type    : LOGIN_PASSWORD_CHANGE,
    payload : value
  }
}

function markAsAuthenticated(value) {
  return {
    type    : MARK_AS_AUTHENTICATED,
    payload : value
  }
}

export {
  changePhoneNumber,
  changePassword,
  markAsAuthenticated,
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [LOGIN_PHONE_NUMBER_CHANGE]: (state, action) => ({
    ...state,
    phone_number: state
  }),
  [LOGIN_PASSWORD_CHANGE]: (state, action) => ({
    ...state,
    password: state
  }),
  [MARK_AS_AUTHENTICATED]: (state, action) => ({
    ...state,
    is_authenticated: action.payload
  }),
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  phone_number: '1',
  password: '',
  is_authenticated: false
};

export default function loginReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/routes/Login/modules/login.js